import { ReactNode } from 'react';
import styles from './style.module.scss';
interface Props {
    title: string;
    icon: ReactNode;
    value: string;
    onClick: () => void;
};

function InfoCard(props: Props) {
    const { title, icon, value, onClick } = props;

    return (
        <div className={styles.container} onClick={onClick}>
            <div className={styles.text}>
                <span className={styles.text_title}>{title}</span>
                <span className={styles.text_value}>{value}</span>
            </div>
            {icon}
        </div>
    );
};

export default InfoCard;
